module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/vercel/path0/src/layouts/Main/index.ts"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-GKG9JSJTZH"],"gtagConfig":{"cookie_expires":0},"pluginConfig":{"head":true,"respectDNT":true,"exclude":[]}},
    }]
